jQuery(function(){
	$( ".change_price" ).change(function() {
		per_unit_mrp 	=	parseInt($(this).val()	);
	  	scanned_qty		=	parseInt($("#spare_transaction_qty").val()	);
	  	new_mrp			=	per_unit_mrp * scanned_qty	;
	  	$("#retail_price").val(new_mrp);
	});
});